<template>
    <footer>
    <div class="footer-content">
        <div class="wave-container">
            <div class="wave"></div>
            <div class="rectangle"></div>
        </div>
        <div class="footer-wrapper">
            <div id="clippath"> </div>
            <div class="container footer-container">
                <div class="footer-row">
                    <div class="footer-column">
                        <img :src="`${baseUrl}/storage/app/media/logo-dark.png`"  alt="Iatse Logo" class="logo" width="220" height="80"/>
                        <small>© All Rights Reserved. I.A.T.S.E. National Benefit Funds.</small>
                    </div>
                </div>
                <div class="footer-row">
                    <div class="footer-icons">
                        <a href="https://www.facebook.com/p/IATSE-National-Benefit-Funds-100063462075974/" target="_blank"><i class='iatse-icon-facebook'></i></a>
                    </div>
                    <div class="footer-buttons">
                        <a :href="`${baseUrl}/en/forgot-credentials`" class="btn btn-outline">
                            FORGOT CREDENTIALS
                        </a>
                        <router-link :to="{ name: 'register' }" class="btn btn-outline">
                            REGISTER
                        </router-link>
                        <router-link :to="{ name: 'login' }" class="btn btn-secondary">
                            LOGIN
                        </router-link>
                    </div>
            </div>
        </div>
    </div>
</div>
<div class="footer-credits">
    <div class="container">
        <a href="http://www.polardesign.com/" target="_blank" class="links w-100">Taft-Hartley Web Design by Polar Design</a>
        <div class="footer-terms">
            <a :href="`${baseUrl}/en/terms-conditions`" target="_blank" class="links">Terms & Conditions</a>
            <p class="links divider"> | </p>
            <a :href="`${baseUrl}/en/privacy-policy`" target="_blank" class="links">Privacy Policy</a>
        </div>
    </div>
</div>
</footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    setup() {
        return {
            baseUrl: process.env.VUE_APP_PUBLIC_URL
        }
    }
 })
</script>

<style lang="scss" scoped>

    a {
        text-decoration: none;
        color: #1e1e1e;
    }

    .footer-content {
        position: relative;
        background: #F6F8FF;
        z-index: 10;

        .btn-outline {
            border: 1px solid #FCFCFC;
            color: #FCFCFC;
        }

        .wave-container {
            position: absolute;
            width: 100%;
            height: 700px;
            overflow: hidden;
            bottom: 0;
            transform: rotate(180deg);
            z-index: -6;

            .wave.home:before {
                background: #E8EFFF;
            }

            .wave {
                display: block;
                position: relative;
                bottom: 0;
                top: 70%;
                height: 40px;
                width: 100%;
                background: #17388C;
                transform: scale(1, 3);
            }

        .wave:before {
            content: "";
            display: block;
            position: absolute;
            border-radius: 100%;
            width: 100%;
            height: 300px;
            background-color: #F6F8FF;
            left: -25%;
            top: 20px;
            z-index: -9;
            @media (max-width: 768px) {
                display: none;
            }
        }

        .wave:after {
            content: "";
            display: block;
            position: absolute;
            border-radius: 100%;
            width: 100%;
            height: 300px;
            background-color: #17388C;
            right: -25%;
            top: -240px;
            clip-path: ellipse(100% 15% at 115% 100%);

            @media (max-width: 768px) {
                display: none;
            }
        }

        .rectangle {
                display: block;
                position: absolute;
                height: 70%;
                width: 100%;
                top: 0;
                background: #17388C;
            }
        }

    .wave-announcements {
        .wave.home:before {
            background: #F6F8FF;
        }
    }

        .links {
            font-weight: 300;
            font-size: 0.875rem;
        }

        .top-layer {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            z-index: 1;
            margin-bottom: -160px;
        }

        .footer-wrapper {
            width: 100%;
            height: 600px;
            position: relative;

            @media (max-width: 768px) {
                height: 400px;
            }

            #clippath {
                display: flex;
                align-items: center;
                justify-content: center;
                background-image: url("../assets/images/clippath.png");
                background-repeat: no-repeat;
                background-size: cover;
                position: absolute;
                width: 100%;
                min-height: 500px;
                bottom: 80%;
                z-index: -5;

                @media (max-width: 768px) {
                    display: none;
                }
            }

            .footer-container {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-end;
                gap: 40px;
                height: 100%;
                padding-bottom: 40px;
                color: #FCFCFC;

                .footer-row {
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    width: 100%;

                    @media (max-width: 768px) {
                        flex-direction: column;
                    }

                    &:nth-child(2) {
                        align-items: center;
                    }

                    .footer-column {
                        display: flex;
                        align-items: flex-start;
                        flex-direction: column;
                        justify-content: space-between;
                        max-width: 50%;

                        @media (max-width: 768px) {
                            max-width: 100%;
                            width: 100%;
                            align-items: center;
                        }

                        .widget-list h4 {
                            color: #FCFCFC;
                        }

                        .widget-list .links {
                            color: #FCFCFC;

                            .display-more {
                                display: none;
                            }
                        }

                        .logo {
                            width: 220px;
                            height: auto;
                            padding-bottom: 15px;

                            @media (max-width: 768px) {
                                width: 160px;
                            }
                        }
                    }

                    .footer-icons {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        gap: 10px;
                        padding-top: 25px;
                        width: 100%;

                        @media (max-width: 768px) {
                            display: none;
                        }

                        i::before {
                            font-size: 30px;
                        }
                    }

                    .footer-buttons {
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        gap: 10px;
                        width: 100%;

                        @media (max-width: 768px) {
                            justify-content: space-between;
                            flex-direction: column;
                        }

                        .btn {
                            text-transform: uppercase;

                            @media (max-width: 768px) {
                                width: 100%;
                            }
                        }
                    }
                }
            }
        }
    }

    .footer-credits {
        background-color: #FCFCFC;

        .container {
            display: flex;
            align-items: center;
            justify-content: space-between;

            @media (max-width: 768px) {
                flex-wrap: wrap;
            }

            .footer-terms {
                width: 100%;
                gap: 15px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                @media (max-width: 768px) {
                    justify-content: space-between;
                }

                .divider {
                    color: #D8D8D8;
                    width: 1px;
                    height: 100%;
                }
            }
        }
    }

    .background-light-blue {
        background-color: #E8EFFF;
    }
</style>